// extracted by mini-css-extract-plugin
module.exports = {"linkChatBlock":"Support_linkChatBlock__323bn","title":"Support_title__3xNSR","buttonsBlock":"Support_buttonsBlock__1Lnvf","subBlock":"Support_subBlock__1NArQ"};